import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CamService } from 'src/app/services/camService/cam.service';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { BulkUploadDialogComponent } from '../bulk-upload-dialog/bulk-upload-dialog.component';
import { ApiService } from 'src/app/services/apiService/api.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { Subject, takeUntil } from 'rxjs';
import { ContentService } from '../../services/content.service';
import { TravelerManagement } from 'src/app/services/dataLayer/CAM/traveler-management.service';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { EmailVerificationComponent } from 'src/app/modules/registration/components/email-verification/email-verification.component';
import { OtpRequestPayload } from 'src/app/models/interface/Registration/registration';
import { NgIf, NgStyle, NgFor, NgClass, TitleCasePipe } from '@angular/common';
import { WaitingComponent } from '../../../../shared/components/waiting/waiting.component';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { CamEmptyStateComponent } from '../cam-empty-state/cam-empty-state.component';
import { MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
    selector: 'app-traveler-managment',
    templateUrl: './traveler-managment.component.html',
    styleUrls: ['./traveler-managment.component.scss'],
    imports: [NgIf, NgStyle, WaitingComponent, ReactiveFormsModule, FormsModule, MatIcon, MatFormField, MatSelect, NgFor, MatOption, MatSuffix, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, NgClass, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, CamEmptyStateComponent, MatButton, MatCheckbox, TitleCasePipe]
})
export class TravelerManagmentComponent implements OnInit {
  B2BCompanyId = "SAA"
  selected = 'Newest';
  CustomFilter!: FormGroup;
  searchString: any;
  Orderby: any = 'Newest';
  pageNumber: number = 1;
  totalPages: number = 0;
  TravellerData: any;
  totalTravelerNumber: number = 0;
  UserStatus: any;
  userType: any;
  branchdata: any;
  Departmentdata: any;
  Department: string = '';
  Branch: string = '';
  filterStatus: any = '';
  heading: string = 'No results found';
  content: string = "We couldn't find what you searched for.";
  IsShow: boolean = true;
  numberOfResult: number = 0;
  dataSource = new MatTableDataSource([]);
  travellerList: any;
  // displayedColumns: string[] = [
  //   'employeeCode',
  //   'employeeName',
  //   'userName',
  //   'branchName',
  //   'department',
  //   'userStatus',
  //   'actions',
  // ];
  displayedColumns: string[] = [];
  filterModalRef!: MatDialogRef<any>;
  loader: boolean = true;
  isFilterApplied: boolean = false;
  userDeactivateModellRef!: MatDialogRef<TemplateRef<any>>;
  private readonly destroy$ = new Subject<void>();
  dynamicContent: any;
  selectedBranchIds: number[] = [];
  companySettingDetails: any = {};
  selectedTravelerForDeactivation: any = null;

  Loader: any = {
    isSpinner: false,
    isEditableClicked: false
  }

  isInitialLoad: boolean = true;
  isPageLandingCalled: boolean = false;

  constructor(
    private readonly _MatDialog: MatDialog,
    private readonly router: Router,
    private readonly _CamApiService: CamService,
    private readonly _ApiService: ApiService,
    public _CommonService: CommonService,
    private readonly _ToastrApiService: ToastrApiService,
    private readonly fb: FormBuilder,
    private readonly _CompanyManagementService: CompanyManagementService,
    private readonly contentService: ContentService,
    private readonly travelerManagement: TravelerManagement,
    private readonly crypto: CryptoService

  ) {
    this.CustomFilter = this.fb.group({
      Active: [false],
      Deactivated: [false],
      branches: this.fb.array([]),
    });
  }
  ngOnInit(): void {
    const stored = localStorage.getItem('companySettings');
    this.userType = this.crypto.getValueFromKey('ISCORPTRAVELARRANGER') as string
    this.setDisplayedColumns()
    // this.companySettingDetails = stored && stored !== 'undefined' ? JSON.parse(stored) : {};
    this.companySettingDetails = stored && stored !== 'undefined' ? JSON.parse(stored) : {};
    this.SelectedOrder(this.Orderby)
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.dynamicContent = res;
    })

    this._ApiService.travelerSubject1.subscribe((data) => {
      if (data?.status) {
        this.searchString = '';

        if (data.DepartmentBranch) {
          this.Branch = data.DepartmentBranch;
          this.Department = '';
        } else {
          this.Branch = '';
          this.Department = '';
        }

        this.filterStatus = this.extractStatus(data?.status);
        this.pageNumber = 1;
        this.Searchtravellerdetails();
      } else if (data == 'Oldest' || data == 'Newest') {
        this.Orderby = data;
      }
    });

    this._CamApiService.dialogClosed$.subscribe((status) => {
      if (status) {
        this.reloadData();
      }
    });


  }

  SearchQuery() {
    this.Branch = '';
    this.pageNumber = 1;
    this.Searchtravellerdetails();
  }

  callByGttm(){
     this.travelerManagement.traveler_management_click('Sort',this.numberOfResult);
  }


  SelectedOrder(OrderType: string) {
    // this.travelerManagement.traveler_management_click('Sort',this.numberOfResult);
    this.Orderby = OrderType;
    this.searchString = '';
    this.pageNumber = 1;
     if (!this.isInitialLoad) {
    this.travelerManagement.traveler_management_clickSortFlt(
      this.Orderby,
       this.Orderby
    );
  }

    this.Searchtravellerdetails();
     this.isInitialLoad = false;
  }

  Searchtravellerdetails(): void {
    this.isFilterApplied = true;
    this.loadTravellerDetails(this.pageNumber);
  }

  private buildTravellerDetailsPayload(): { B2BId: string; B2BUserRole: string } {
    return {
      B2BId: this.crypto.getValueFromKey('SUBAGENTID') as string,
      B2BUserRole: this.crypto.getValueFromKey('ISCORPTRAVELARRANGER') as string,
    };
  }

  private toTravellerQueryParam(value: string | string[] | number[] | undefined | null): string {
    if (value == null || value === '') {
      return '';
    }
    if (Array.isArray(value)) {
      return value.join(',');
    }
    return String(value);
  }

  private loadTravellerDetails(page: number = this.pageNumber): void {
    this.loader = true;
    this.pageNumber = page;

    const payload = this.buildTravellerDetailsPayload();

    this._CamApiService
      .Posttravellerdetails(
        this.Orderby ?? 'Newest',
        this.searchString ?? '',
        this.toTravellerQueryParam(this.Department),
        this.toTravellerQueryParam(this.Branch),
        this.toTravellerQueryParam(this.filterStatus),
        page.toString(),
        payload
      )
      .then((response: any) => this.applyTravellerDetailsResponse(response))
      .catch((error: any) => {
        console.error('Error fetching traveller details:', error);
        this.loader = false;
      });
  }

  private applyTravellerDetailsResponse(response: any): void {
    if (response?.status !== 'Success') {
      this.loader = false;
      return;
    }

    this.loader = false;
    const list = (response.data?.GetAllTravelerData ?? []).map((item: any) => ({
      ...item,
      rowid: item.rowid ?? item.RowID,
    }));
    this.dataSource.data = list;
    this.numberOfResult = list.length;

    if (response.data?.getbranchdata) {
      this.branchdata = response.data.getbranchdata;
    }
    if (response.data?.getdepartmentdata) {
      this.Departmentdata = response.data.getdepartmentdata;
    }

    this.totalTravelerNumber = response.data?.Table_6?.[0]?.TotalRows ?? 0;
    this.totalPages = response.data?.totalPage ?? 0;
    this.IsShow = list.length > 0;

    if (!this.isPageLandingCalled) {
      this.travelerManagement.page_landing(
        'Traveler Management',
        this.totalTravelerNumber,
        'Traveler Management Workflow'
      );
      this.isPageLandingCalled = true;
    }

    if (this.branchdata?.length) {
      this.loadBranches();
    }
  }
  viewEmployeeDetails(userId: any, guid: string): void {
    localStorage.setItem('travelerGUID', guid);
    sessionStorage.setItem('userId', userId);
    this.travelerManagement.traveler_view_click(this.numberOfResult);
    if (userId && guid) {
      this.router.navigate([
        '/cam/traveler-details/personal-info',
        userId,
        guid,
      ]);
    }
    this._CommonService.setData('heading', false);
    this._CommonService.setData('camSidebar', false);
  }

  openDialog(): void {
    this.travelerManagement.traveler_add('Upload bulk travelers', this.totalTravelerNumber,'Upload_bulk');
    this._MatDialog.open(BulkUploadDialogComponent, {
      panelClass: 'seatSelectorPopup',
      //  data: { branchdata: this.branchdata , Departmentdata: this.Departmentdata} // You can pass data if needed
    });
  }

  // ✅ open filter
  openFilter(template: TemplateRef<any>) {
    this.travelerManagement.traveler_management_click('Filter',this.numberOfResult);
    this.filterModalRef = this._MatDialog.open(template, {
      panelClass: 'custom-popup-gen-filter-popup-type',
    });
    // data: { branchdata: this.commonObjPipes.GetAllRuleAppliedOnData.pipe, selectedLists: this.receivedAppliedOnID } // You can pass data if needed,
  }

  // ✅ branch change handle karna (agar ID chahiye)
  onBranchChange(branch: any, event: any) {
    if (event.checked) {
      console.log('Selected Branch:', branch.ID);
    }
  }

  // ✅ apply filters
  applyFilters() {
    this.travelerManagement.traveler_management_click('Apply',this.numberOfResult);
    const selectedBranches = this.CustomFilter.value.branches
      .map((checked: boolean, i: number) =>
        checked ? this.branchdata[i].ID : null
      )
      .filter((v: any) => v !== null);

    this.selectedBranchIds = selectedBranches;

    const selectedStatus = [];
    if (this.CustomFilter.value.Active) selectedStatus.push('1');
    if (this.CustomFilter.value.Deactivated) selectedStatus.push('0');

    const filterData = {
      status: selectedStatus,
      DepartmentBranch: selectedBranches,
    };

    this._MatDialog.closeAll();
    this._ApiService.travelerSubject1.next(filterData);
  }

  get branchesFormArray() {
    return this.CustomFilter.get('branches') as FormArray;
  }

  AddNewTraveler() {
    this.travelerManagement.traveler_add('Add new traveler', this.totalTravelerNumber,'Add_manual');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('guid');
    this.router.navigate(['/cam/traveler-details/add-new-traveler']);
    this._CommonService.setData('heading', true);
    this._CommonService.setData('camSidebar', true);
  }

  reloadData(): void {
    this.pageNumber = 1;
    this.loadTravellerDetails(1);
  }

  extractStatus(status: string[] | string | undefined): string {
    if (!status) {
      return '';
    }
    if (Array.isArray(status)) {
      return status.join(',');
    }
    return String(status);
  }

  OrderBY() {
    if (!this.dataSource || !this.dataSource.data) return;
    if (this.Orderby === 'Oldest') {
      this.dataSource.data.sort((a: any, b: any) => {
        const dateA = new Date(a.BookedOn);
        const dateB = new Date(b.BookedOn);
        return dateA.getTime() - dateB.getTime();
      });
    } else if (this.Orderby === 'Newest') {
      this.dataSource.data.sort((a: any, b: any) => {
        const dateA = new Date(a.BookedOn);
        const dateB = new Date(b.BookedOn);
        return dateB.getTime() - dateA.getTime();
      });
    }
  }

  nextPage(): void {
    if (this.pageNumber < this.totalPages) {
      this.loadTravellerDetails(this.pageNumber + 1);
    }
  }

  previousPage(): void {
    if (this.pageNumber > 1) {
      this.loadTravellerDetails(this.pageNumber - 1);
    }
  }
  onChangePassword(user: any): void {
    const email = user?.Email_Address;
    if (!email) {
      return;
    }
    this._CamApiService
      .resetAdminUserPassword(email)
      .then((response) => {
        if (response?.status === 'Success') {
          this._ToastrApiService.show(
            'success',
            'Change password email sent to employee successfully.'
          );
        } else {
          this._ToastrApiService.show(
            'error',
            'Change password email not sent.'
          );
        }
      })
      .catch((error) => {
        this._ToastrApiService.show('error', 'something went wrong.');
      });
  }

  isLoggedInUser(element: any): boolean {
    const selectedUserGuid = localStorage.getItem("userGuid");
    if (!selectedUserGuid || !element?.GUID) {
      return false;
    }

    return element.GUID.toUpperCase() === selectedUserGuid.toUpperCase();
  }

  onResendUser(user: any) {
  this.travelerManagement.traveler_click(this.numberOfResult, 'Resend');
  const email = user?.Email_Address;
  if (!email) {
      this._ToastrApiService.show('error', 'Email not found');
      return;
  }
  this.Loader.isSpinner = true;

  this._CamApiService.resendInvite(email.toLowerCase())
    .then((res: any) => {
      this.Loader.isSpinner = false;

      if (res?.status === 'Created') {
        this._ToastrApiService.show('success', 'Invite resent successfully');
      } else {
        this._ToastrApiService.show('error', 'Failed to resend invite');
      }
    })
    .catch((err: any) => {
      this.Loader.isSpinner = false;
      this._ToastrApiService.show(
        'error',
        err?.error?.message || 'Something went wrong'
      );
    });
}

  onDeactivateUser(user: any, template: TemplateRef<any>): void {
  this.travelerManagement.traveler_click(this.numberOfResult,'Deactivate',);
  const LoginEmail = this.crypto.getValueFromKey('LOGINNAME') as string;
  const otpPayload: OtpRequestPayload = {
    type: 'email',
    otpAction: "mobileOrEmailValidation",
    value: LoginEmail.toLowerCase(),
    channel: 'email',
    companyId: "SAA",
    b2BId: null,
    b2BUserId: null,
    eventName: "UserDeactivate"
  };

  this.Loader.isSpinner = true;

  // Step 1: Send OTP first
  this._CamApiService.sendOTP(otpPayload)
    .then((res: any) => {
      const checksum = res.data.checksum;
      this.Loader.isSpinner = false;

      // Step 2: Open OTP dialog
      const dialogRef = this._MatDialog.open(EmailVerificationComponent, {
        data: {
          Email: LoginEmail.toLowerCase(),
          verifyMode: 'email',
          otpChecksum: checksum,
          actionType: 'UserDeactivate',
          panelClass: 'custom-passport-dialog'
        }
      });

      // Step 3: Open confirm popup only after OTP verification
      dialogRef.afterClosed().subscribe((result) => {
        if (result === 'verified') {
          this.selectedTravelerForDeactivation = user;
          this.openModal(template);
        }
      });
    })
    .catch((error: any) => {
      this.Loader.isSpinner = false;

      const apiErrorCode = error?.error?.details?.[0]?.code;

      if (apiErrorCode === 'DUPLICATE_ENTRY') {
        this._ToastrApiService.show(
          'error',
          'OTP already sent. Please wait 30 seconds before trying again.'
        );
      } else {
        this._ToastrApiService.show(
          'error',
          error?.error?.details?.[0]?.title || 'Failed to send OTP'
        );
      }
    });
}

cancel(){
  this.travelerManagement.deactivate_click('Cancel');
}

  onConfirmDeactivateUser(): void {
  if (!this.selectedTravelerForDeactivation) {
    return;
  }
  this.travelerManagement.deactivate_click('Deactivate');
  const user = this.selectedTravelerForDeactivation;
  const payload = {
    B2BUserId: String(user.SA_User_ID),
    B2BId: user.Subagent_ID,
    ContactId: String(user.ContactId),
    AccountId: String(user.AccountId)
  };

  this.Loader.isSpinner = true;
   
  // Step 4: Call deactivate API after popup confirm
  this._CamApiService
    .deactivateUser(this.B2BCompanyId, payload)
    .then((response) => {
      this.Loader.isSpinner = false;
      if (response?.status === 'Success') {
        // this.travelerManagement.traveler_click(this.numberOfResult, 'Deactivate');
       
        this.travelerManagement.deactivate_success('Deactivate','Success');
        this._ToastrApiService.show(
          'success',
          'User deactivated successfully.'
        );

        this.userDeactivateModellRef?.close();
        this.selectedTravelerForDeactivation = null;
        this.refreshData();
      } else {
        this._ToastrApiService.show('error', 'User deactivation failed.');
      }
    })
    .catch((error) => {
      this.Loader.isSpinner = false;
      this._ToastrApiService.show(
        'error',
        error?.error?.message ||
        'An error occurred while deactivating the user.'
      );
    });
}

  refreshData(): void {
    this.isFilterApplied = false;
    this.filterStatus = '';
    this.Branch = '';
    this.Department = '';
    this.selectedBranchIds = [];
    this.pageNumber = 1;
    this.searchString = '';
    this.Orderby = 'Newest';
    this.selected = 'Newest';
    this.loadTravellerDetails(1);
  }

  ellipsizeString(text: string, maxLength: number = 15) {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...';
    }
    return text;
  }

  // ✅ branch ke liye FormArray controls banaye
  // loadBranches() {
  //   const arr = this.branchdata.map(() => this.fb.control(false));
  //   this.CustomFilter.setControl('branches', this.fb.array(arr));
  // }

  loadBranches() {
    const arr = this.branchdata.map((branch: any) =>
      this.fb.control(this.selectedBranchIds.includes(branch.ID))
    );

    this.CustomFilter.setControl('branches', this.fb.array(arr));
  }

  openModal(template: TemplateRef<any>) {
    this.userDeactivateModellRef = this._MatDialog.open(template, {
      panelClass: ['custom-popup-gen-policy-filter-popup', 'traveler-deactivate-popup'],
      disableClose: false,
      autoFocus: false,
    });

    this.userDeactivateModellRef.afterClosed().subscribe(() => {
      this.selectedTravelerForDeactivation = null;
    });
  }

  setDisplayedColumns() {
  this.displayedColumns = [
    'employeeCode',
    'employeeName',
    'userName',
    'branchName',
    'department',
    'userStatus',
  ];

  if (this.userType == '0') {
    this.displayedColumns.push('actions');
  }
}
}
